module.exports = __webpack_public_path__ + "img/Eva.e94fa3c7.png";